import { render, staticRenderFns } from "./LayBottom.vue?vue&type=template&id=08100b35&scoped=true&"
import script from "./LayBottom.vue?vue&type=script&lang=js&"
export * from "./LayBottom.vue?vue&type=script&lang=js&"
import style0 from "./LayBottom.vue?vue&type=style&index=0&id=08100b35&lang=less&scoped=true&"
import style1 from "./LayBottom.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08100b35",
  null
  
)

export default component.exports